/* eslint-disable max-len */
import styled from 'styled-components';

export const StyledKakarikoRadio = styled.div`
  .radio-selections {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  .checked-icon {
    box-shadow: inset 0 0 0 1px rgba(var(--primary-base-hex), 1),
      inset 0 -1px 0 rgba(var(--primary-base-hex), 0.1) !important;
    background-image: radial-gradient(
      circle at center,
      rgba(var(--primary-base-hex), 1) 40%,
      transparent 40%,
      white 55%
    ) !important;

    &::before {
      content: '';
      display: block;
      height: 16px;
      width: 16px;
    }

    input:hover ~ & {
      background-color: var(--primary-base);
    }
  }

  .error {
    color: var(--warning-base);
  }

  .icon {
    border-radius: 50%;
    box-shadow: inset 0 0 0 1px rgba(16, 22, 26, 0.2),
      inset 0 -1px 0 rgba(16, 22, 26, 0.1);
    background-color: var(--white-full);
    background-image: linear-gradient(
      180deg,
      hsla(0, 0%, 100%, 0.8),
      hsla(0, 0%, 100%, 0)
    );
    height: 16px;
    width: 16px;

    root.Mui-focusVisible & {
      outline: 2px auto rgba(19, 124, 189, 0.6);
      outline-offset: 2;
    }

    &.error {
      box-shadow: inset 0 0 0 1px rgba(var(--warning-base-hex), 1),
        inset 0 -1px 0 rgba(var(--warning-base-hex), 0.1) !important;
    }

    input:hover ~ & {
      background-color: var(--default-light);
    }

    input:disabled ~ & {
      box-shadow: 'none';
      background: 'rgba(206,217,224,.5)';
    }
  }
`;

export const StyledLabel = styled.label<{ disabled?: boolean }>`
  color: var(--black-full);
  font-family: 'Source Sans Pro';
  font-size: 14px;
  font-style: 'normal';
  font-weight: 'normal';
  line-height: 21px;
  ${({ disabled }) =>
    disabled &&
    `
    cursor: not-allowed;
  `}
`;

export const StyledLegend = styled.legend`
  color: var(--black-full);
  font-family: 'Source Sans Pro';
  font-style: 'normal';
  font-weight: 600;
  font-size: 14px;
  grid-row: 1;
  grid-column: 1;
  line-height: 34px;
  margin-right: 10px;
`;
